module.exports = __webpack_public_path__ + "img/img12.bcf1b35a.svg";